import {
  FlexBox,
  Icon,
  IconSizes,
  Switch,
  Table,
  Text,
} from '@dixa/lib-shared-habla';

type DataSourceTableRowProps = {
  url: string;
  index: number;
  isExcluded: boolean;
  onToggle: (url: string, index: number) => void;
};

export const DataSourceTableRow = ({
  url,
  index,
  isExcluded,
  onToggle,
}: DataSourceTableRowProps) => {
  return (
    <Table.Tr key={index}>
      <Table.Td>
        <Text.ExternalLink href={url} target="_blank" rel="noreferrer">
          <FlexBox
            alignItems="center"
            gap="100"
            display="inline-flex"
            flexDirection="row"
          >
            <Icon name="external-link" size={14 as IconSizes} />
            {url}
          </FlexBox>
        </Text.ExternalLink>
      </Table.Td>
      <Table.Td>
        <Switch
          name={isExcluded ? 'passive' + index : 'active' + index}
          value={isExcluded ? 'excluded' : 'included'}
          checked={!isExcluded}
          onChange={() => onToggle(url, index)}
        />
      </Table.Td>
    </Table.Tr>
  );
};
